import React, { useMemo, useState } from "react";
import {
  MapPin,
  Info,
  Lock,
  Map as MapIcon,
  Sparkles,
} from "lucide-react";
import temprorary from '../../Imgs/collection-modern-tech-gadgets-including-smartphones-earbuds-smartwatch-headphones-tablet-charger-array-various-400391239.webp'
import { useEffect } from "react";
import api from "../../api";
function daysLeft(dateStr) {
  const today = new Date();
  const d = new Date(dateStr);
  const diff = Math.ceil((d - today) / (1000 * 60 * 60 * 24));

  if (diff < 0) return "Expired";
  if (diff === 0) return "Last day";
  if (diff === 1) return "1 day left";
  return `${diff} days left`;
}

export default function ProductDetailsAndOffers({
  SearchedProduct,
  offers,
  isLoggedIn,
  selectedArea,
}) {
  const [product, setProduct] = useState({
    productName: "Loading...",
    categoryPath: "Loading...",
    attributes: [],
    media: [],
  });
  const img = product.media[0]?.url || temprorary;
  const [showFullDescription, setShowFullDescription] = useState(false);


useEffect(() => {
  if (!SearchedProduct?.hyveProductId) return;

  const fetchProductDetails = async () => {
    try {
      const response = await api.get(
        `/master-catalogue/api/catalogue/product/${SearchedProduct.hyveProductId}`,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );

      setProduct(response.data);
    } catch (error) {
      console.error("Failed to fetch product details", error);
    }
  };

  fetchProductDetails();
}, [SearchedProduct?.hyveProductId]);


  return (
    <section className="bg-white/95 border border-slate-200/80 rounded-2xl shadow-xl p-5 space-y-4">
      <header className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="space-y-2">
          <p className="inline-flex items-center gap-1 text-xs text-blue-700 bg-blue-50 rounded-full px-2 py-0.5">
            <Sparkles className="w-3 h-3" /> Popular in Dubai
          </p>

          <h2 className="text-lg md:text-xl font-semibold leading-snug">
            {product.productName}     
          </h2>

          <div className="flex flex-wrap gap-2 text-[0.75rem]">
            <span className="px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 font-medium">
              {product.categoryPath}
            </span>

            {selectedArea !== "Near me" && (
              <span className="px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700">
                Showing offers around{" "}
                <span className="font-semibold">{selectedArea}</span>
              </span>
            )}
          </div>
        </div>

        <img
          src={img}
          alt={product.productName}
          className="w-24 h-24 md:w-28 md:h-28 rounded-xl object-cover shadow-lg"
        />
      </header>

      <div className="grid gap-5 md:grid-cols-[minmax(0,0.9fr)_minmax(0,1.3fr)]">
        {/* LEFT SIDE */}
        <div>
          <h3 className="text-sm font-semibold mb-1.5">
            Key specifications
          </h3>
          <ul className="list-disc list-inside text-sm text-slate-600 space-y-1">
            {product.attributes?.map((attr) => (
              <li key={attr.code}>
                <span className="font-medium capitalize">{attr.code.replace(/_/g, " ")}:</span>{" "}
                {attr.value}
                {attr.unit ? ` ${attr.unit}` : ""}
              </li>
            ))}
          </ul>
        {/* ---------------- DESCRIPTION ---------------- */}
        {product.description?.trim() && (
          <div>
            <h2 className="font-semibold mb-1">Description</h2>

            <p
              className={`text-sm text-gray-700 whitespace-pre-line ${
                !showFullDescription ? "line-clamp-2" : ""
              }`}
            >
              {product.description}
            </p>

            <button
              onClick={() =>
                setShowFullDescription((prev) => !prev)
              }
              className="mt-1 text-sm text-indigo-600 hover:underline"
            >
              {showFullDescription ? "View less" : "View more"}
            </button>
          </div>
        )}

        </div>

        {/* RIGHT SIDE */}
        <div>
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-semibold">In-store offers</h3>
            <span className="text-[0.75rem] text-slate-500">
              {offers.length} offer{offers.length !== 1 ? "s" : ""} found
            </span>
          </div>

          {offers.length === 0 ? (
            <p className="text-xs text-slate-500">
              No offers found for this area yet. Try a different area or "Near
              me".
            </p>
          ) : (
            <ul className="space-y-2">
              {offers
                .slice()
                .sort((a, b) => a.price - b.price)
                .map((offer) => {
                  const isLockedLowest =
                    offer.isLowest && !isLoggedIn;
                  const showStoreName = isLoggedIn ;
                    // !offer.isLowest || (offer.isLowest && isLoggedIn);

                  return (
                    <li
                      key={offer.id}
                      className={`grid gap-3 md:grid-cols-[minmax(0,1.7fr)_auto] items-center rounded-2xl border px-3 py-2.5 text-sm bg-white/95 ${
                        offer.isLowest
                          ? "border-emerald-500/80 bg-emerald-50/40"
                          : "border-slate-200/80"
                      }`}
                    >
                      <div className="flex items-center gap-3 min-w-0">
                        <img className="w-9 h-9 rounded-full bg-indigo-50 flex items-center justify-center text-[0.7rem] font-bold text-indigo-700" src={offer.store?.logo || temprorary}>
                        </img>

                        <div className="space-y-1 min-w-0">
                          <div className="flex flex-wrap items-center gap-2">
                            <span className="font-semibold truncate max-w-[14rem]">
                              {showStoreName
                                ? offer.store?.storeName || "Store Name"
                                : "Login to unlock this store"}
                            </span>

                            {offer.isLowest && (
                              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-600 text-white text-[0.7rem]">
                                <Lock className="w-3 h-3" /> Lowest price
                              </span>
                            )}
                          </div>

                          <div className="flex flex-wrap gap-2 text-[0.75rem] text-slate-500">
                            <span className="font-semibold text-slate-900">
                              AED {offer.offerPrice.toLocaleString()}
                            </span>

                            <span>
                              {offer.branches[0].distanceKm.toFixed(1)} km away
                            </span>

                            <span>
                              {["Last day", "Expired"].includes(
                                daysLeft(offer.endDate)
                              ) ? (
                                <span
                                  className={(() => {
                                    const d = new Date(offer.endDate);
                                    const today = new Date();
                                    const diff = Math.ceil(
                                      (d - today) /
                                        (1000 * 60 * 60 * 24)
                                    );
                                    if (diff < 3) return "text-red-500";
                                    if (diff < 5)
                                      return "text-orange-500";
                                    return "text-green-500";
                                  })()}
                                >
                                  {daysLeft(offer.endDate)}
                                </span>
                              ) : (
                                <>
                                  Ends {offer.endDate} ·{" "}
                                  <span
                                    className={(() => {
                                      const d = new Date(offer.endDate);
                                      const today = new Date();
                                      const diff = Math.ceil(
                                        (d - today) /
                                          (1000 * 60 * 60 * 24)
                                      );
                                      if (diff < 3) return "text-red-500";
                                      if (diff < 5)
                                        return "text-orange-500";
                                      return "text-green-500";
                                    })()}
                                  >
                                    {daysLeft(offer.endDate)}
                                  </span>
                                </>
                              )}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col md:items-end gap-1">
                        <button
                          type="button"
                          onClick={() => {
                            const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                              offer.store.storeName + " " + offer.branches[0].branchName
                            )}`;
                            window.open(url, "_blank");
                          }}
                          className="inline-flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-full border border-slate-300/80 text-[0.75rem] text-slate-700 hover:border-indigo-500 hover:text-indigo-600"
                        >
                          <MapPin className="w-3.5 h-3.5" /> Directions
                        </button>

                        <button
                          type="button"
                          onClick={() =>
                            alert("Show offer details popup")
                          }
                          className="inline-flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-full border border-transparent text-[0.75rem] text-indigo-700 hover:bg-indigo-50"
                        >
                          <Info className="w-3.5 h-3.5" /> View details
                        </button>
                      </div>

                      {isLockedLowest && (
                        <p className="md:col-span-2 flex items-center gap-1.5 text-[0.7rem] text-slate-600 mt-1">
                          <Lock className="w-3.5 h-3.5" /> Login or sign up
                          to see the store name for the lowest price.
                        </p>
                      )}
                    </li>
                  );
                })}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
}
